import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Atish Bagate
 */
export const useArchiveTherapyNote = () =>
  useMutationWithLoading(
    async (params: {
      appointmentUuid: string;
      therapyNoteUuid: string;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).archiveAppointmentTherapy(
        params?.appointmentUuid,
        params?.therapyNoteUuid,
        params?.xTENANTID
      )
  );
